<template>
  <div>
    <div class="item-card-header">
      <div>
        <a-input
          v-if="canEditNumb"
          size="small"
          :defaultValue="item.cardName"
          @blur="(value) => saveNameEdit(value.target.value)"
        />
        <span v-else>{{ item.cardName }}</span>
        <a-icon
          v-if="!canEditNumb"
          type="edit"
          theme="twoTone"
          style="padding-left: 6px;"
          v-show="type === 'edit'"
          @click="() => editItem()"
        />
      </div>
      <a-icon
        type="delete"
        theme="twoTone"
        two-tone-color="red"
        v-show="type === 'edit'"
        @click="() => deleteItem()"
      />
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      canEditNumb: false
    }
  },
  methods: {
    saveNameEdit(value) {
      this.canEditNumb = false
      this.$emit('saveNameEdit', value, this.item)
    },
    editItem() {
      this.canEditNumb = true
    },
    deleteItem() {
      this.$emit('deleteItem', this.item)
    }
  }
}
</script>

<style lang="less" scoped>
.item-card-header,
.placeholder-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 16px;
  border-top: 4px solid #4a90e2;
  background: #f8f8f8;
  border-bottom: 1px solid #d9d9d9;
  color: #000;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  i {
    cursor: pointer;
  }
}
</style>
